import { useCallback, useContext } from "react";
import useApi from "./useApi";
import { AppContext, StationContext } from "contexts";
import { getStations } from "apis";
import useAuth from "./useAuth";
import { PagesKeys, Path } from "enums";
import useMount from "./useMount";
import useRouter from "./useRouter";

const useStations = (props) => {
  const { apisState } = useContext(AppContext);
  const { allStations, setAllStations } = useContext(StationContext);
  const { stationCodes } = useAuth({ pageKey: PagesKeys.STATIONS });
  const { pathname } = useRouter();
  const key = "all-stations";
  const getAllStations = useApi({
    api: getStations,
    key: key,
    params: {
      stationCodes,
    },
  });

  const fetch = useCallback(
    async () => {
      if (Path.Stations !== pathname && allStations.length > 0) {
        return allStations;
      }

      const res = await getAllStations?.request(
        {
          page: 1,
          perPage: 1000,
        },
        () => {},
        { useLoader: true }
      );

      // remove duplicate station code
      const uniqueMap = new Map();
      const stations = res.stations.filter(
        (station) => !uniqueMap.has(station.stationCode) && uniqueMap.set(station.stationCode, true)
      );
      setAllStations(stations);
      props?.onSuccess?.(stations);

      return stations;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useMount(async () => {
    if (props?.initialRun) {
      await fetch();
    }
  });

  return {
    fetch,
    allStations,
    loading: !!apisState?.[key]?.loading,
  };
};

export default useStations;
